import { render } from "./역대병원장.vue?vue&type=template&id=4ca1e128"
import script from "./역대병원장.vue?vue&type=script&lang=js"
export * from "./역대병원장.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__